// extracted by mini-css-extract-plugin
export default {"wrapper":"nodata_wrapper__EquuT","img":"nodata_img__3Yquc","message":"nodata_message__HW5CG"};